import {
  Box,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  useTheme,
  Grid,
  Select,
  FormControl,
  MenuItem,
  Button,
  TextField
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { imageOnError } from '../helpers';
import { PAGES_SLUGS, THEME_COLORS } from '../variables';
import { MainContainer } from '../styles';
import { useEffect, useState } from 'react';
import { getSizeGuides, sendBudgetRequest } from '../api';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { BsCheckCircle } from 'react-icons/bs';
import { IconContext } from 'react-icons';

const customizeResume = ({ products }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [selectedSize, setSelectedSize] = useState(null);
  const [fileData, setFileData] = useState(null);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleChange = (event) => {
    // Input Select
    setSelectedSize(event.target.value);
  };

  const [quantities, setQuantities] = useState(1);

  const handleIncrease = (id, baseValue) => {
    setQuantities((prev) => {
      const currentValue =
        prev[id] !== undefined ? prev[id] : parseFloat(baseValue) || 0;
      return {
        ...prev,
        [id]: Number((currentValue + 1).toFixed(2))
      };
    });
  };

  const handleDecrease = (id, baseValue) => {
    setQuantities((prev) => {
      const currentValue =
        prev[id] !== undefined ? prev[id] : parseFloat(baseValue) || 0;
      const newValue = currentValue > 0 ? currentValue - 1 : 0;
      return {
        ...prev,
        [id]: Number(newValue.toFixed(2))
      };
    });
  };

  const handleInputChange = (id, event) => {
    const value = parseFloat(event.target.value, 10);
    setQuantities((prev) => ({
      ...prev,
      [id]: isNaN(value) ? 0 : value
    }));
  };

  useEffect(() => {
    getSizeGuides().then((data) => {
      console.log('products[1].title: ', products[1].title);
      if (products[1].title.toLowerCase().includes('contemporary')) {
        setFileData(data.contemporary);
      }
      if (products[1].title.toLowerCase().includes('regular')) {
        setFileData(data.regular);
      }
      if (products[1].title.toLowerCase().includes('slim')) {
        setFileData(data.slim);
      }
    });
  }, []);

  function handleConfirmOrder(e) {
    e.preventDefault();

    setIsLoading(true);

    sendBudgetRequest({
      products: products,
      size: selectedSize,
      notes: quantities
    })
      .then(() => {
        setIsLoading(false);
        setShowConfirmation(true);
      })
      .catch(({ response: { status } }) => {
        if (status === 401) {
          navigate(PAGES_SLUGS.login);
        } else if (status === 400 || status > 401) {
          setIsLoading(false);
        }
      });
  }

  if (showConfirmation) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          marginTop: { xs: 3, md: 4 }
        }}
      >
        <IconContext.Provider
          value={{
            style: { color: THEME_COLORS.lightGreen }
          }}
        >
          <BsCheckCircle size={50} />
        </IconContext.Provider>
        <Typography
          sx={{
            marginTop: 2,
            fontWeight: 600
          }}
        >
          {t('budgetRequest.successMessage')}
        </Typography>
      </Box>
    );
  }

  return (
    <MainContainer>
      <Grid container spacing={2}>
        {/* 🟢 Lado Esquerdo */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              ml: 'auto',
              p: 2,
              borderRadius: 2
            }}
          >
            <Typography
              variant='h6'
              gutterBottom
              align='left'
              fontWeight={'bold'}
            >
              Selecione um tamanho
            </Typography>

            <FormControl fullWidth>
              <Select
                labelId='size-select-label'
                id='size-select'
                value={selectedSize || ''}
                label='Tamanho'
                onChange={handleChange}
                required
              >
                {products[1].variants.map((size) => (
                  <MenuItem
                    key={size.params[9].value}
                    value={size.params[9].value}
                  >
                    {size.params[9].value}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            {selectedSize && (
              <Table>
                <TableBody>
                  {/* 🔎 Filtra o objeto com medida igual ao tamanho selecionado */}
                  {fileData.find((item) => item.medida === selectedSize) &&
                    Object.entries(
                      fileData.find((item) => item.medida === selectedSize)
                    )
                      .filter(([key]) => key !== 'medida')
                      .map(([key, value]) => (
                        <TableRow key={key}>
                          <TableCell
                            sx={{
                              borderBottom: `1px solid ${THEME_COLORS.gray}`,
                              fontWeight: 'bold',
                              textAlign: 'left !important',
                              padding: '0'
                            }}
                          >
                            {key}
                          </TableCell>

                          <TableCell
                            sx={{
                              textAlign: 'right !important',
                              display: 'flex',
                              justifyContent: 'end'
                            }}
                          >
                            <Box
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                columnGap: '10px',
                                padding: '8px 0',
                                margin: '0',
                                height: '30px'
                              }}
                            >
                              <Button
                                variant='outlined'
                                onClick={() => handleDecrease(key, value)}
                                sx={{
                                  height: '30px',
                                  'min-width': '35px',
                                  padding: 0
                                }}
                              >
                                -
                              </Button>
                              <Button
                                variant='outlined'
                                onClick={() => handleIncrease(key, value)}
                                sx={{
                                  height: '30px',
                                  'margin-left': '2px',
                                  'min-width': '35px',
                                  padding: 0
                                }}
                              >
                                +
                              </Button>

                              <TextField
                                type='number'
                                value={
                                  quantities[key] !== undefined
                                    ? quantities[key]
                                    : value
                                }
                                onChange={(e) => handleInputChange(key, e)}
                                inputProps={{
                                  min: 0,
                                  step: '0.01',
                                  style: {
                                    textAlign: 'center',
                                    'font-size': '10px',
                                    height: '30px'
                                  }
                                }}
                                sx={{
                                  mx: 1,
                                  width: '70px',
                                  height: '30px',
                                  margin: '0'
                                }}
                              />
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                </TableBody>
              </Table>
            )}
          </Box>
        </Grid>

        {/* 🔵 Lado Direito - Resumo */}
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              ml: 'auto', // Isto empurra o resumo para o canto direito
              p: 2,
              borderRadius: 2
            }}
          >
            <Typography
              variant='h6'
              gutterBottom
              align='left'
              fontWeight={'bold'}
            >
              Resumo
            </Typography>

            <Table>
              <TableBody>
                {products.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell
                      sx={{
                        borderBottom: `1px solid ${THEME_COLORS.gray}`,
                        fontWeight: 'bold',
                        textAlign: 'left !important',
                        padding: '0'
                      }}
                    >
                      {products[3].title.includes('curta') && index > 3
                        ? t(`customize.steps.${index + 2}`)
                        : t(`customize.steps.${index + 1}`)}
                    </TableCell>
                    <TableCell
                      sx={{
                        textAlign: 'right !important',
                        padding: '0',
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center'
                      }}
                    >
                      {item.title}
                      <Box
                        component='img'
                        src={item.images[0]}
                        alt={item.reference}
                        onError={(e) => {
                          imageOnError(e);
                        }}
                        sx={{
                          aspectRatio: '1',
                          objectFit: 'contain',
                          width: '38px',
                          backgroundColor: 'white',
                          borderRadius: theme.shape.borderRadius / 10,
                          border: `1px solid ${THEME_COLORS.gray}`,
                          ml: 1,
                          margin: '6px 0 6px 4px'
                        }}
                      />
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>

            <Typography variant='caption' display='block' mt={2} align='right'>
              {t('customize.resume.warning')}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      {selectedSize !== null && (
        <Box component='form' onSubmit={handleConfirmOrder}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: 3,
              marginTop: 3
            }}
          >
            <LoadingButton
              variant='contained'
              type='submit'
              title={t('forms.submitRequest')}
              loading={isLoading}
            >
              {t('forms.submitRequest')}
            </LoadingButton>
          </Box>
        </Box>
      )}
    </MainContainer>
  );
};

export default customizeResume;
